import styled from '@emotion/styled';
import { TabletWidth } from '../../../global.style';
import { getColor } from '../../common/UICommon';

export const CriteriaV3FullStaticScreen = styled.div<{ imgDesktop: string }>`
  background-image: url(${({ imgDesktop }) => imgDesktop});
  background-size: cover;
  background-position: center;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;

  @media (max-width: ${TabletWidth}px) {
    background-color: ${getColor('BEIGE_10')};
    background-image: none;
  }
`;

export const CriteriaV3FullStaticScreenContentWrapper = styled.div`
  max-width: 400px;
  margin-top: 180px;
  text-align: left;

  @media (max-height: 760px) {
    margin-top: auto;
    margin-bottom: auto;
  }

  @media (max-width: ${TabletWidth}px) {
    min-width: min(calc(100% - 48px), 330px);
    margin: 66px 0px 18px;
  }
`;

export const CriteriaV3AnswerButtonsWrapper = styled.div`
  min-width: min(calc(100% - 48px), 330px);
`;

export const CriteriaV3Title = styled.div`
  color: ${getColor('BLACK')};
  font-family: Lora;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px;
  margin-bottom: 4px;
  text-align: center;
`;

export const CriteriaV3Subtitle = styled.div`
  color: ${getColor('GRAY_80')};
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin-bottom: 24px;
  text-align: center;
`;

export const CriteriaV3Logo = styled.img`
  display: none;

  @media (max-width: ${TabletWidth}px) {
    display: block;
    position: absolute;
    top: 42px;
    left: 50%;
    transform: translateX(-50%);
    width: 52px;
  }
`;

export const CriteriaV3AnswerBtn = styled.button`
  font-family: 'Poppins';
  width: 100%;
  background-color: ${getColor('WHITE')};
  color: ${getColor('GRAY_80')};
  border-radius: 100px;
  border: 1px solid ${getColor('WHITE')};
  text-align: left;
  padding: 16px;
  margin-bottom: 12px;
  font-size: 16px;
  line-height: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-weight: 500;

  &.secondary {
    background-color: #ffffff80;
    border: 1px solid #ffffff80;
    color: #2e1f1c;
  }

  &:hover {
    border: 1px solid ${getColor('BEIGE_30')};
  }

  @media (max-width: ${TabletWidth}px) {
    &:hover {
      border: 1px solid ${getColor('WHITE')};
    }
  }
`;

export const CriteriaV3AnswerImg = styled.img`
  width: 24px;
  margin-right: 12px;
`;
